import { render, staticRenderFns } from "./info_segepidegeneral.vue?vue&type=template&id=5a7a622a"
import script from "./info_segepidegeneral.vue?vue&type=script&lang=js"
export * from "./info_segepidegeneral.vue?vue&type=script&lang=js"
import style0 from "./info_segepidegeneral.vue?vue&type=style&index=0&id=5a7a622a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports